import { Injectable } from '@angular/core';
import { FormControlBase } from '../../../form-models/form-control-base';

@Injectable()
export class DynamicFormControlViewsService {
  constructor() {}

  getControlLabel(control: FormControlBase<any>): string {
    // if (this.isRequired(control)) return ' * ';
    // return '';
    if (control) {
      let text = control.label === null || control.label === 'undefined' ? '' : control.label;
      if (!control.required && !control.disabled) {
        text = ' - ' + 'Optional';
        return text;
      }
      return '';
    }
    return '';
  }

  isRequired(control: FormControlBase<any>): boolean {
    if (control && control.required && (!control.disabled || control.overridingInProgress)) return true;
    return false;
  }
}
